/**
 * Archivo Js que permite definir, administrar, controlar y configurar las rutas del modulo 
 * Contratos, se integra facilmente con el router principal del Vue facilitando 
 * la creacion y el mantenimiento de las peticiones en el proyecto
 */

 /**
  * Definicion de lista de rutas aplicadas al modulo Contrato de Salud
  */
const contratoRouter = [
	{
		/**Definicion de la ruta del modulo Contratos de Salud */
		path: '/contrato',

		/**Definicion del nombre de la ruta Contratos de Salud */
		name: 'contrato',

		/**Definicion de la vista Contratos de Salud */
		component: resolve => {
			require.ensure(['@/views/contrato/Contrato.vue'], () => {
				resolve(require('@/views/contrato/Contrato.vue'))
			})
		},

		/**Definicion de metadatos */
		meta: {
			requiresAuth: true
		},

		/**Definicion de redireccionamiento al submodulo referenciacion */
		redirect: {
			name: 'referenciacion'
		},

		/**Lista de rutas de los submodulos asociados al modulo de Contratos de Salud */
		children: [
			{
				path: 'referenciacion',
				name: 'referenciacion',
				component: resolve => {
					require.ensure(['@/views/contrato/Referenciacion.vue'], () => {
						resolve(require('@/views/contrato/Referenciacion.vue'))
					})
				},
				meta: {
					requiresAuth: true
				}
			}
		]
	}
]

/**Exportamos las rutas del modulo Administrar */
export default contratoRouter;